module.exports = {"title":"About","category":"tech","path":"/about","date":"2014-07-11T23:46:37.121Z","body":"<h2>Social Networking / Contact</h2>\n<p>You can find me on these social networks :</p>\n<ul>\n<li><a href=\"http://twitter.com/PhilippeLewin\">Twitter</a> @PhilippeLewin</li>\n<li><a href=\"https://www.linkedin.com/profile/view?id=119132112\">Linkedin</a> /in/plewin</li>\n<li><a href=\"http://www.meetup.com/members/127983432/\">Meetup</a></li>\n<li><a href=\"https://github.com/plewin\">GitHub</a> @plewin</li>\n</ul>\n<p>You can also join me by email at philippe dot lewin at gmail dot com.</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./about/index.md
// module id = 551
// module chunks = 0